import { completeRegistration, getOrganizationsShortList, submitOrganization } from "@/pages/auth/api"
import { SubmitOrganizationFormType, submitOrganizationSchema } from "@/pages/auth/validation-schema"
import { Button, Select } from "@/shared/components"
import { zodResolver } from "@hookform/resolvers/zod"
import { useMutation, useQuery } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import Cookies from "js-cookie"
import { Notice } from "@/shared/utils/notice.tsx"
import { useNavigate } from "react-router-dom"
import { useState } from "react"

const InspectorForm = () => {
  const session_id = Cookies.get("session_id")
  const [openEnded, setOpenEnded] = useState<boolean>(false)

  const { control, handleSubmit, setValue, watch } = useForm<SubmitOrganizationFormType>({
    resolver: zodResolver(submitOrganizationSchema),
    defaultValues: {
      session_id: session_id ?? ""
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ["companies"],
    queryFn: getOrganizationsShortList
  })

  const options = data?.results.map(item => ({
    value: item.id,
    label: item.name
  }))

  const completeReg = useMutation({
    mutationFn: completeRegistration
  })

  const create = useMutation({
    mutationFn: submitOrganization,
    onSuccess: () => {
      Notice.success("Sizning so`rovingiz yuborildi", 300)
      setOpenEnded(true)
      completeReg.mutate({ session_id: session_id! })
      Cookies.remove("session_id")
    },
    onError: () => {
      Notice.error("Oops!")
    }
  })

  const onSubmit = (form: SubmitOrganizationFormType) => {
    create.mutate({
      ...form,
      session_id: session_id!
    })
  }

  return (
    <>
      {openEnded ? (
        <div className={"text-center font-medium"}>Suravingiz yuborildi , Iltimos biroz kuting</div>
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <div className="grid grid-cols-1 gap-4">
              <label>
                <span className="text-[#2A3845]">Регион</span>
                <Select.Form
                  control={control}
                  name="organization_id"
                  options={options || []}
                  loading={isLoading}
                  placeholder="Выберите регион"
                  onSelect={option => setValue("organization_id", option?.value as any)}
                  className="mt-1"
                />
              </label>
            </div>
            <Button type="submit">Отправить запрос</Button>
          </div>
        </form>
      )}
    </>
  )
}

export default InspectorForm
